// Central site configuration. All external links and identity values live here only.
export const siteConfig = {
  name: "Poojan Patel",
  initials: "PP",
  brand: "Manufacturing Automation & Product Quality Systems",
  role: "QMS Automation • Product Quality Systems • Digital Manufacturing • RCA • Operational Excellence",
  headline: "Manufacturing Automation & Product Quality Systems",
  subHeadline:
    "Streamlining Manufacturing Data, Product Quality Systems & Digital Workflows.",
  portfolioBaseUrl: "https://poojanqmsautomation.com",
  domainDisplay: "PoojanQMSAutomation.com",
  socialPreviewUrl: "/poojan-qms-automation-social-preview.png",
  resumeUrl: "/assets/Poojan_Patel_Digital_Manufacturing_Automation_Resume.pdf",
  resumeDownloadFilename: "Poojan_Patel_Digital_Manufacturing_Automation_Resume.pdf",
  onePagerUrl: "/assets/Poojan_Patel_Recruiter_One_Pager.pdf",
  onePagerDownloadFilename: "Poojan_Patel_Recruiter_One_Pager.pdf",
  vcardUrl: "/assets/Poojan_Patel.vcf",
  vcardDownloadFilename: "Poojan_Patel.vcf",
  portfolioQrUrl: "/assets/poojan-portfolio-qr.svg",
  linkedinUrl: "https://www.linkedin.com/in/poojanpatel14",
  githubUrl: "https://github.com/patelpoojan14-afk",
  githubEnabled: true,
  emailAddress: "poojan_patel14@yahoo.com",
  location: "Brampton, Ontario, Canada",
};

export const CONFIDENTIALITY_NOTICE =
  "All product names, instrument identifiers, lot identifiers, datasets, process parameters and visualizations presented in this portfolio are synthetic or anonymized demonstrations created to illustrate technical methodologies and capabilities. No proprietary employer data, confidential manufacturing records, controlled documents or credentials are displayed.";

export const SYNTHETIC_NOTE =
  "Synthetic Demonstration Specification — all values are deterministically generated and contain no real process data.";
